import { CustomThemeConfigContext } from '@/contexts/CustomThemeConfigContext/CustomThemeConfigContext.js';
import { useContext } from 'react';

export const useCustomThemeConfig = () => {
  const CustomThemeConfig = useContext(CustomThemeConfigContext);

  return CustomThemeConfig;
};
